import { Jobsite, JobsiteAndProject } from './jobsiteType';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


class JobsiteApi {

    static async create(jobsite: Jobsite) {
        try {
            const response = await fetch(`${API_BASE_URL}/jobsites`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ jobsite: jobsite }),
                credentials: 'include', // Include cookies in the request
            });

            const responseBody = await response.json();

            if (response.status === 201) {
                return responseBody
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                if (responseBody.error.includes('duplicate')) {
                    // This checks if the word "duplicate" appears in the error message
                    //throw new Error('Duplicated data entries' || `Error: Status ${response.status}`);
                    throw new Error(`Duplicated data entries status ${response.status}`);
                }
                else {
                    throw new Error(response.statusText);
                }
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to create jobsite: ${error.message}`);
            } else {
                throw new Error('Failed to create jobsite: An unknown error occurred.');
            }
        }
    }

    static async getJobsiteByEmployeeCode(employee_code: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/jobsites/emp_code/${employee_code}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                //credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status < 300) {

                const jobsites: Jobsite[] = responseBody.data.map((item: any) => {
                    return {
                        jobsite_id: item.attributes.jobsite_id,
                        name: item.attributes.name,
                        jobsite_description: item.attributes.jobsite_description,
                        company_code: item.attributes.company_code,
                        company_name: item.attributes.company_name,
                        project_name: item.attributes.project_name,
                        address_1: item.attributes.address_1,
                        address_2: item.attributes.address_2,
                        city: item.attributes.city,
                        state: item.attributes.state,
                        zip: item.attributes.zip,
                        latitude: item.attributes.latitude,
                        longitude: item.attributes.longitude,
                        created_by_account_id: item.attributes.created_by_account_id,
                        created_at: item.attributes.created_at,
                        updated_at: item.attributes.updated_at
                    };
                });

                return jobsites;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                //console.log('body======', responseBody.error, `Status ${responseBody.error}`);

                //throw new Error(response.statusText || `Error: Status ${response.status}`);
                throw new Error(`${responseBody.error} status ${response.status}`);
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get jobsite: ${error.message}`);
            } else {
                throw new Error('Failed to get jobsite: An unknown error occurred.');
            }
        }
    }


    static async getJobsiteAndProject() {
        try {
            const response = await fetch(`${API_BASE_URL}/jobsites/jobsites_projects`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {

                const jobsiteAndProject: JobsiteAndProject[] = responseBody.data.map((item: any) => {
                    return {
                        jobsite_id: item.attributes.jobsite_id,
                        name: item.attributes.name,
                        jobsite_description: item.attributes.jobsite_description,
                        company_code: item.attributes.company_code,
                        company_name: item.attributes.company_name,
                        project_id: item.attributes.project_id,
                        address_1: item.attributes.address_1,
                        address_2: item.attributes.address_2,
                        city: item.attributes.city,
                        state: item.attributes.state,
                        zip: item.attributes.zip,
                        latitude: item.attributes.latitude,
                        longitude: item.attributes.longitude,
                        created_by_account_id: item.attributes.created_by_account_id,
                        created_at: item.attributes.created_at,
                        updated_at: item.attributes.updated_at,
                        project_name: item.attributes.project_name,
                        project_description: item.attributes.project_description,
                        project_type: item.attributes.project_type

                    };
                });
                return jobsiteAndProject;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else if (response.status === 404) { //for no record is found with this account!!
                return [];
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);
                throw new Error(`${responseBody.error} status ${response.status}`);
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get jobsite: ${error.message}`);
            } else {
                throw new Error('Failed to get jobsite: An unknown error occurred.');
            }
        }
    }


    static async get() {
        try {
            const response = await fetch(`${API_BASE_URL}/jobsites/`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include', // Include cookies in the request
            });

            //console.log('=====response======', response)
            const responseBody = await response.json();

            if (response.status === 200) {

                const jobsites: Jobsite[] = responseBody.data.map((item: any) => {
                    return {
                        jobsite_id: item.attributes.jobsite_id,
                        name: item.attributes.name,
                        jobsite_description: item.attributes.jobsite_description,
                        company_code: item.attributes.company_code,
                        company_name: item.attributes.company_name,
                        project_id: item.attributes.project_id,
                        address_1: item.attributes.address_1,
                        address_2: item.attributes.address_2,
                        city: item.attributes.city,
                        state: item.attributes.state,
                        zip: item.attributes.zip,
                        latitude: item.attributes.latitude,
                        longitude: item.attributes.longitude,
                        created_by_account_id: item.attributes.created_by_account_id,
                        created_at: item.attributes.created_at,
                        updated_at: item.attributes.updated_at
                    };
                });
                return jobsites;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else if (response.status === 404) { //for no companies is found with this account!!
                return [];
            }
            else {
                //console.log('body======', responseBody.error, `Status ${response.status}`);
                throw new Error(`${responseBody.error} status ${response.status}`);
            }

        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to get jobsite: ${error.message}`);
            } else {
                throw new Error('Failed to get jobsite: An unknown error occurred.');
            }
        }
    }


    static async update(jobsite_id: string, jobsite: Jobsite) {
        try {
            const response = await fetch(`${API_BASE_URL}/jobsites/${jobsite_id}`, {
                method: 'PATCH',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ jobsite: jobsite }),
            });

            const responseBody = await response.json();

            if (response.status === 200) {
                //return company;
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to update jobsite: ${error.message}`);
            } else {
                throw new Error('Failed to update jobsite: An unknown error occurred.');
            }
        }
    }

    static async delete(jobsite_id: string) {
        try {
            const response = await fetch(`${API_BASE_URL}/jobsites/${jobsite_id}`, {
                method: 'DELETE',
                credentials: 'include',  // If you need to send cookies
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const responseBody = await response.json();
            //console.log('body======', response.status);

            if (response.status === 200) {
                return {
                    status: response.status,
                    ok: response.ok,
                };
            }
            else if (response.status === 401) {
                throw new Error(`${response.status}: Session expired. Try to refresh your browser.`);
            }
            else {
                throw new Error(`${responseBody.error}, status: ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to delete jobsite: ${error.message}`);
            } else {
                throw new Error('Failed to delete jobsite: An unknown error occurred.');
            }
        }
    }

}

export default JobsiteApi;